import settings from './settings.json';
const env = process.env.NODE_ENV || 'production';


export default settings[env]; 